import { render, staticRenderFns } from "./WizardModal.vue?vue&type=template&id=0370da34&scoped=true&"
import script from "./WizardModal.vue?vue&type=script&lang=js&"
export * from "./WizardModal.vue?vue&type=script&lang=js&"
import style0 from "./WizardModal.vue?vue&type=style&index=0&id=0370da34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0370da34",
  null
  
)

export default component.exports